import { render, staticRenderFns } from "./AssetTypeLabel.vue?vue&type=template&id=699e8e0e&"
import script from "./AssetTypeLabel.vue?vue&type=script&lang=js&"
export * from "./AssetTypeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports